import { useState, useEffect } from 'react';

// True when the viewport is at/under the app's mobile breakpoint (768px,
// the same value the DJPal layout uses to collapse the header actions).
// Reacts live to resize / device-rotation so layout swaps without a reload.
// Matches mobile web AND the Capacitor app (both render at narrow widths);
// stays false on desktop web + Electron.
export function useIsNarrow(maxWidth = 768) {
    const query = `(max-width: ${maxWidth}px)`;
    const get = () =>
        typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia(query).matches
            : false;

    const [narrow, setNarrow] = useState(get);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia(query);
        const onChange = (e) => setNarrow(e.matches);
        // Safari < 14 only has the deprecated add/removeListener API.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        setNarrow(mq.matches);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [query]);

    return narrow;
}
